export default "__VITE_ASSET__CMrYVZUU__"